import Vue from 'vue'
// 1.导入路由
import Router from 'vue-router'
import HomePage from '@/components/HomePage.vue'
import Home from '@/components/Home.vue'
import Image from '@/view/Image/Image.vue'
import Events from '@/view/Events/events.vue'
import Nwp from '@/view/NwpVerification/nwp.vue'
import cloudAni from '@/view/cloudAnimation/cloudAnimation.vue'
// 2.使用路由
Vue.use(Router)

// 路由配置表
const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
    },
    {
        path: '/area',
        name: 'area',
        component: Home,
        children:[
           
            {
                path: '/area/:area/image',
                name: 'prod',
                // component: cloudAni,
                component: resolve => require([ '@/view/cloudAnimation/cloudAnimation.vue' ], resolve),
            },
            // {
            //     path: '/area/:area/events',
            //     name: 'animation',
            //     component: Image,
            // },
            {
                path: '/area/:area/events',
                name: 'events',
                // component: Image,
                component: resolve => require([ '@/view/cloudAnimation/cloudAnimation.vue' ], resolve),
                // component: resolve => require([ '@/view/Image/Image.vue' ], resolve),
            },
            {
                path: '/area/:area/weather',
                name: 'weather',
                // component: Image,
                component: resolve => require([ '@/view/cloudAnimation/cloudAnimation.vue' ], resolve),
                // component: resolve => require([ '@/view/Image/Image.vue' ], resolve),
            },
            {
                path: '/area/:area/climate',
                name: 'climate',
                // component: Image
                component: resolve => require([ '@/view/cloudAnimation/cloudAnimation.vue' ], resolve),
                // component: resolve => require([ '@/view/Image/Image.vue' ], resolve),
            },
            {
                path: '/area/:area/3D',
                name: '3D',
                // component: Image
                component: resolve => require([ '@/view/Image3D/image3D.vue' ], resolve),
            },
            {
                path: '/area/:area/nwpVerification',
                name: 'nwpVerification',
                // component: Nwp
                component: resolve => require([ '@/view/NwpVerification/nwp.vue' ], resolve),
            },
            {
                path: '/area/:area/InteractiveAnalysis',
                name: 'InteractiveAnalysis',
                component: resolve => require([ '@/view/InteractiveAnalysis/Interactive.vue' ], resolve),
            },
            {
                path: '/area/:area/home',
                name: 'home',
                // component: cloudAni,
                component: resolve => require([ '@/view/home/Home.vue' ], resolve),
            },
        ], 
    }
]

// 3.创建VueRouter
const router = new Router({
    // 配置路由和组件之间的应用关系, 这里必须是 routes
    routes,
    mode: 'history'
})

// 4.将Router对象传入到Vue实例
export default router